<app-landing-wallpaper landingPageImg="assets/images/newsletter.jpg">
  <div class="lists-wrapper">
    <div class="background-wrapper">
      <div class="container form-wrapper">
        <div class="form-title flex flex-column">
          <div class="title color-black">ISCRIVITI ALLA NEWSLETTER</div>
          <div class="description color-main">
            Aiutaci a trovare la tua vacanza
          </div>
        </div>
        <form (submit)="submitForm()" [formGroup]="form">
          <div class="row justify-content-md-between justify-content-center">
            <div class="col-md-6 col-12 mt-4">
              <label class="form-label" for="name">Nome</label>
              <input
                [class.is-invalid]="isInvalid(form, 'first_name')"
                aria-describedby="name"
                class="form-control shadow form-control-lg newsletter-input rounded-0"
                formControlName="first_name"
                id="name"
                type="text"
                >
              @if (isInvalid(form, 'first_name')) {
                <small class="form-text text-danger">
                  @if (getError(form, 'first_name')?.required) {
                    <span>
                      Nome è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'first_name')) {
                    <span>
                      {{ serverSideError(form, 'first_name') }}
                    </span>
                  }
                </small>
              }
            </div>
            <div class="col-md-6 col-12 mt-4">
              <label class="form-label" for="name">Cognome</label>
              <input
                [class.is-invalid]="isInvalid(form, 'last_name')"
                aria-describedby="lastName"
                class="form-control form-control-lg newsletter-input shadow rounded-0"
                formControlName="last_name"
                id="lastName"
                type="text"
                >
              @if (isInvalid(form, 'last_name')) {
                <small class="form-text text-danger">
                  @if (getError(form, 'last_name')?.required) {
                    <span>
                      Cognome è obbligatorio
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'last_name')) {
                    <span>
                      {{ serverSideError(form, 'last_name') }}
                    </span>
                  }
                </small>
              }
            </div>

            <div class="col-12 mt-4">
              <label class="form-label" for="Email">Email</label>
              <input
                [class.is-invalid]="isInvalid(form, 'email')"
                aria-describedby="Email"
                class="form-control shadow  form-control-lg newsletter-input rounded-0"
                formControlName="email"
                id="Email"
                type="email"
                >
              @if (isInvalid(form, 'email')) {
                <small class="form-text text-danger">
                  @if (getError(form, 'email')?.required) {
                    <span>
                      Email è obbligatorio
                    </span>
                  }
                  @if (getError(form, 'email')?.email) {
                    <span>
                      L'email non è valida
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'email')) {
                    <span>
                      {{ serverSideError(form, 'email') }}
                    </span>
                  }
                </small>
              }
            </div>
          </div>
          <div class="row col-12 mt-5 justify-content-center mx-0">
            <button
              class="submit-button text-color col-lg-4 col-md-6 col-12"
              mat-button
              type="submit">
              Iscriviti
            </button>
          </div>
          <div class="row title-privacy-policy">
            <div class="col">Privacy Policy</div>
          </div>
          @if (settingsService.settings(); as setting) {
            <div class="row privacy-wrapper">
              <mat-radio-group [class.is-invalid]="isInvalid(form, 'profile_privacy')" class="col-md-12 p-0"
                color="primary"
                formControlName="profile_privacy">
                <mat-radio-button [value]="true" class="me-4">Acconsento</mat-radio-button>
                <mat-radio-button [value]="false">Non acconsento</mat-radio-button>
              </mat-radio-group>
              @if (isInvalid(form, 'profile_privacy')) {
                <small class="form-text text-danger pb-3">
                  @if (getError(form, 'profile_privacy')?.required) {
                    <span>
                      Dovresti accettare la nostra privacy
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'profile_privacy')) {
                    <span>
                      {{ serverSideError(form, 'profile_privacy') }}
                    </span>
                  }
                </small>
              }
              <div class="col-md-12">
                Al trattamento dei dati dell’Interessato per l’invio di
                comunicazioni promozionali circa sconti, offerte, servizi o
                eventi di {{ setting.agency_name }}.
              </div>
              <mat-radio-group [class.is-invalid]="isInvalid(form, 'third_part_privacy')"
                class="col-md-12 p-0" color="primary"
                formControlName="third_part_privacy">
                <mat-radio-button [value]="true" class="me-4">Acconsento</mat-radio-button>
                <mat-radio-button [value]="false">Non acconsento</mat-radio-button>
              </mat-radio-group>
              @if (isInvalid(form, 'third_part_privacy')) {
                <small class="form-text text-danger pb-3">
                  @if (getError(form, 'third_part_privacy')?.required) {
                    <span>
                      Dovresti accettare la nostra privacy
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'third_part_privacy')) {
                    <span>
                      {{ serverSideError(form, 'third_part_privacy') }}
                    </span>
                  }
                </small>
              }
              <div class="col-md-12">
                Trattamento dei dati dell’Interessato per finalità di finalità
                di profilazione, quali ad esempio l’analisi delle preferenze
                operate con mezzi automatizzati per il miglioramento
                dell’offerta
              </div>
              <mat-radio-group [class.is-invalid]="isInvalid(form, 'marketing_privacy')" class="col-md-12 p-0"
                color="primary"
                formControlName="marketing_privacy">
                <mat-radio-button [value]="true" class="me-4">Acconsento</mat-radio-button>
                <mat-radio-button [value]="false">Non acconsento</mat-radio-button>
              </mat-radio-group>
              @if (isInvalid(form, 'marketing_privacy')) {
                <small class="form-text text-danger pb-3">
                  @if (getError(form, 'marketing_privacy')?.required) {
                    <span>
                      Dovresti accettare la nostra privacy
                    </span>
                  }
                  <!-- server-side validation errors -->
                  @if (serverSideError(form, 'marketing_privacy')) {
                    <span>
                      {{ serverSideError(form, 'marketing_privacy') }}
                    </span>
                  }
                </small>
              }
              <div class="col-md-12">
                <label>
                  Comunicazione dei dati dell’Interessato a società partner di
                  {{ setting.agency_name }} , per finalità di invio di
                  comunicazioni commerciali e promozionali di prodotti e/o
                  servizi da parte di tali società terze (punto 1 lett. e).
                </label>
              </div>
            </div>
          }
        </form>
      </div>
    </div>
  </div>
</app-landing-wallpaper>
